import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, isRef as _isRef, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Transition as _Transition, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "upload-overlay"
}
const _hoisted_2 = {
  key: 1,
  class: "p-3"
}
const _hoisted_3 = {
  key: 1,
  class: "p-4 text-center"
}
const _hoisted_4 = {
  key: 1,
  class: "p-4 text-center"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "pinned-message top-menu"
}
const _hoisted_7 = {
  key: 0,
  class: "mr-3"
}
const _hoisted_8 = { class: "min-width-0 flex-fill" }
const _hoisted_9 = { class: "text-primary font-weight-bold mb-1" }
const _hoisted_10 = { class: "text-truncate" }
const _hoisted_11 = { class: "ml-3" }
const _hoisted_12 = { class: "back-to-buddy-list d-none mr-3" }
const _hoisted_13 = { class: "flex-fill min-width-0" }
const _hoisted_14 = { class: "d-flex align-items-center min-width-0" }
const _hoisted_15 = { class: "text-truncate flex-fill m-0" }
const _hoisted_16 = { class: "text-nowrap buttons" }
const _hoisted_17 = {
  key: "selected",
  class: "m-0"
}
const _hoisted_18 = {
  key: 1,
  class: "m-0"
}
const _hoisted_19 = { class: "d-flex min-width-0 align-items-center" }
const _hoisted_20 = { class: "text-truncate flex-fill" }
const _hoisted_21 = {
  key: 0,
  class: "mt-2 d-flex align-items-center"
}
const _hoisted_22 = { class: "d-inline-block m-0 p-0" }
const _hoisted_23 = { class: "flex-fill text-truncate" }
const _hoisted_24 = { class: "text-uppercase" }
const _hoisted_25 = ["href"]
const _hoisted_26 = ["href", "title"]
const _hoisted_27 = {
  key: 1,
  class: "mt-2 text-muted"
}
const _hoisted_28 = {
  key: 0,
  class: "ml-4 text-nowrap mt-2"
}
const _hoisted_29 = { class: "show-side-menu d-none ml-3" }

import toggleMessagePin from "~/operatorApplication/ts/service/dialog/toggleMessagePin";
import {__} from "~/ts/library/Translate";
import OperatorApplicationDialogHistory
    from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationDialogHistory.vue";
import OperatorApplicationDialogTopMenuButton
    from "~/operatorApplication/vue/dialogs/dialog/topmenu/OperatorApplicationDialogTopMenuButton.vue";
import OperatorApplicationPlatformIcon from "~/operatorApplication/vue/misc/OperatorApplicationPlatformIcon.vue";
import OperatorApplicationExportDialog
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/OperatorApplicationExportDialog.vue";
import BuddyListItemContextMenu from "~/operatorApplication/vue/dialogs/buddyList/item/BuddyListItemContextMenu.vue";
import OperatorApplicationSendToSupportDialog
    from "~/operatorApplication/vue/dialogs/dialog/topmenu/OperatorApplicationSendToSupportDialog.vue";
import CoreUiChatHistoryNotification from "~/core-ui/vue/chat/CoreUiChatHistoryNotification.vue";
import ClientIconsBeforeName from "~/operatorApplication/vue/dialogs/ClientIconsBeforeName.vue";
import OperatorApplicationDialogTextarea
    from "~/operatorApplication/vue/dialogs/dialog/textarea/OperatorApplicationDialogTextarea.vue";
import MyIconButton from "~/cabinet/vue/interface/button/MyIconButton.vue";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {computed, getCurrentInstance, inject, onBeforeUnmount, onMounted, ref, watch} from "vue";
import {OperatorApplicationDialogsStore} from "~/operatorApplication/ts/store/OperatorApplicationDialogsStore";
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import StringHelper from "~/ts/library/StringHelper";
import ElConfirm from "~/core-ui/vue/ui/ElConfirm";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import OperatorApplicationDialogHistoryExposeInterface
    from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationDialogHistoryExposeInterface";
import OperatorApplicationDialogTextareaExposeInterface
    from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationDialogTextareaExposeInterface";
import {isInSelectedSectionInjectionKey} from "~/operatorApplication/vue/layout/OperatorApplicationSectionInjection";
import {addDisposableEvent} from "~/ts/vuePlugins/useDisposableEvent";
import {
    COPY_SHORTCUT,
    EVENT_OPEN_MESSAGE_SEARCH_TAB,
    OperatorApplicationEventManager
} from "~/operatorApplication/ts/OperatorApplicationEventManager";
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";
import Events from "~/ts/library/Events";
import {
    OPERATOR_ELECTRON_IPC_ANSWER_ON_MESSAGE_ACTION,
    OPERATOR_ELECTRON_IPC_COPY_MESSAGE_ACTION, OPERATOR_ELECTRON_IPC_COPY_SELECTED_MESSAGES_ACTION
} from "~/operatorApplication/electron/src/ipc/ElectronIpcActionsConstant";
import {OPERATOR_STATUS_OFFLINE} from "~/chat/ts/data/OperatorStatus";
import OperatorApplicationUploadHelper from "~/operatorApplication/ts/request/OperatorApplicationUploadHelper";
import Punycode from "~/ts/library/Punycode";
import UrlParser from "../../../../../../nodejs/src/Library/UrlParser";
import OperatorApplicationExportPayloadDialogInterface
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/OperatorApplicationExportDialogInterface";
import toggleClientMute from "~/operatorApplication/ts/service/buddyList/toggleClientMute";
import DateHelper from "~/ts/library/Date";
import {
    DialogChatAreaExposeInterface, SCROLL_TO_CLIENT_MESSAGE_EVENT_NAME, ScrollToClientMessageByIdPayloadInterface
} from "~/operatorApplication/vue/dialogs/dialog/DialogChatAreaExposeInterface";
import {getFaviconUrl} from "~/core-ui/ts/CoreUiHelpersMixin";
import startWebRtcCall from "~/operatorApplication/ts/service/dialog/startWebRtcCall";
import CabinetClientDialogFooter from "~/operatorApplication/vue/dialogs/dialog/CabinetClientDialogFooter.vue";
import MyLoader from "~/cabinet/vue/interface/data/MyLoader.vue";
import OperatorApplicationHtmlify from "~/operatorApplication/vue/misc/OperatorApplicationHtmlify.vue";
import getLastClientDialogStatus from "~/operatorApplication/ts/data/getLastClientDialogStatus";
import ChangeDialogStatusDialog from "~/operatorApplication/vue/dialogs/dialog/sidemenu/ChangeDialogStatusDialog.vue";
import OperatorApplicationBuddyList from "~/operatorApplication/ts/service/OperatorApplicationBuddyList";
import getOperatorStatusDescr from "~/operatorApplication/vue/dialogs/dialog/sidemenu/getOperatorStatusDescr";
import {getSclon} from "~/ts/vuePlugins/NumbersPlugin";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "DialogChatArea"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    userdata: {},
    site: {},
    buddyList: {},
    cobrowse: { type: Boolean },
    hideTopMenu: { type: Boolean },
    shortMessageMargin: { type: Boolean },
    disableBackground: { type: Boolean }
  }, {
    "showMessageSearch": { type: Boolean },
    "showMessageSearchModifiers": {},
  }),
  emits: ["update:showMessageSearch"],
  setup(__props: any, { expose: __expose }) {

let props = __props;

let showMessageSearch = _useModel<boolean>(__props, "showMessageSearch");

let history = ref<OperatorApplicationDialogHistoryExposeInterface>();
let textarea = ref<OperatorApplicationDialogTextareaExposeInterface>();
let isInSelectedSection = inject(isInSelectedSectionInjectionKey);

let forceShowSideMenu = ref(false);
let dragStarted = ref(false);
let exportDialog = ref(false);
let sendToSupportDialog = ref(false);

let selectedMessages = ref<OperatorApplicationApi.OperatorApplicationMessageOpenApiModel[]>([]);
let instance = getCurrentInstance();


function showFreeDialogForSite(): boolean {
    return site.value ? OperatorAccountStore.showFreeDialogForSite(site.value.id) : false;
}

usernameChanged(props.userdata.username);
addDisposableEvent(OperatorApplicationEventManager.addEventListener(
    COPY_SHORTCUT,
    () => {
        if (isInSelectedSection.value) {
            if (selectedMessages.value.length) {
                copySelectedMessages();
            }
        }
    }
));


watch(computed(() => props.userdata.username), (newUsername, oldUsername) => {
    usernameChanged(newUsername, oldUsername);
});

function usernameChanged(newUsername: string, oldUsername?: string) {
    selectedMessages.value.splice(0, selectedMessages.value.length);
    ClientUserdataStore.subscribe(props.userdata.username, props.buddyList, instance.proxy);
    if (oldUsername) {
        unsubscribe(oldUsername);
    }
}

function unsubscribe(username: string) {
    ClientUserdataStore.unsubscribe(username, props.buddyList, instance.proxy);
}

onBeforeUnmount(() => {
    unsubscribe(props.userdata.username);
});

function isDragEventWithFiles(e: DragEvent) {
    if (isInSelectedSection.value) {
        if (e.dataTransfer) {
            for (let i = 0; i < e.dataTransfer.items.length; i++) {
                if (e.dataTransfer.items[i].kind == "file") {
                    return true;
                }
            }
        }
    }
    return false;
}

let count = 0;

function onElUploadChange(event: any) {
    textarea.value.uploadOnChange(event);
    count = 0;
    dragStarted.value = false;
}

onMounted(() => {

    addDisposableEvent(Events.addEventListener("dragenter", document, (e: DragEvent) => {
        if (isDragEventWithFiles(e)) {
            if (!count) {
                dragStarted.value = true
            }
            count++;
        }
    }));

    addDisposableEvent(Events.addEventListener("dragover", document, (e) => {
        e.preventDefault();
    }));

    addDisposableEvent(Events.addEventListener("dragleave", document, (e: DragEvent) => {
        if (isDragEventWithFiles(e)) {
            count--;
            if (!count) {
                dragStarted.value = false;
            }
        }
    }));

    addDisposableEvent(Events.addEventListener("drop", document, () => {
        count = 0;
        dragStarted.value = false;
    }));


    addDisposableEvent(OperatorApplicationEventManager.addEventListener(
        OPERATOR_ELECTRON_IPC_ANSWER_ON_MESSAGE_ACTION,
        (messageId: number) => {
            if (isInSelectedSection.value) {
                setReplyToMessageId(messageId);
            }
        }
    ));

    addDisposableEvent(OperatorApplicationEventManager.addEventListener(
        OPERATOR_ELECTRON_IPC_COPY_MESSAGE_ACTION,
        (messageId: number) => {
            if (isInSelectedSection.value) {
                copySelectedMessages(messageId);
            }
        }
    ));

    addDisposableEvent(OperatorApplicationEventManager.addEventListener(
        OPERATOR_ELECTRON_IPC_COPY_SELECTED_MESSAGES_ACTION,
        () => {
            if (isInSelectedSection.value) {
                copySelectedMessages();
            }
        }
    ));

    addDisposableEvent(OperatorApplicationEventManager.addEventListener(SCROLL_TO_CLIENT_MESSAGE_EVENT_NAME, (payload: ScrollToClientMessageByIdPayloadInterface) => {
        OperatorApplicationBuddyList.scrollToClientMessageByIdPayload = null;
        if (payload.username == props.userdata.username) {
            moveToMessageById(payload.messageId);
        }
    }));

    if (OperatorApplicationBuddyList.scrollToClientMessageByIdPayload?.username === props.userdata.username) {
        OperatorApplicationEventManager.emit(
            SCROLL_TO_CLIENT_MESSAGE_EVENT_NAME,
            OperatorApplicationBuddyList.scrollToClientMessageByIdPayload
        );
    }
});


let crossOperatorsChat = computed(() => {
    if (props.userdata.type.isCrossOperatorsChat) {
        return OperatorAccountStore.crossOperatorChat.value[props.userdata.username];
    }
    return null;
});


let directCrossOperatorsChatOperatorLogin = computed(() => {
    return crossOperatorsChat.value?.login;
});

let isDirectCrossOperatorsChat = computed(() => {
    return !!directCrossOperatorsChatOperatorLogin.value;
});

let directCrossOperatorsChatOperator = computed(() => {
    return OperatorAccountStore.operatorsDictionary.value[directCrossOperatorsChatOperatorLogin.value];
});

let crossOperatorsChatGroup = computed(() => {
    return crossOperatorsChat.value?.group;
})


let isOnline = computed(() => {
    return OperatorAccountStore.status.value.id != OPERATOR_STATUS_OFFLINE;
});

let isUnavailableBecauseOfLicenseLimit = computed(() => {
    return !!(site.value?.isUnavailableBecauseOfLicenseLimit);
});

let uploadAction = computed(() => {
    return (new OperatorApplicationUploadHelper())
        .setTag("operatorApplication")
        .getUrl();
});

let site = computed(() => {
    return OperatorAccountStore.sitesDictionary.value[props.userdata.siteId];
});

let isFree = computed(() => {
    return !!site.value?.isFree;
});

let domain = computed(() => {
    if (site.value) {
        let lastPage = props.userdata.lastPage;
        return lastPage ? Punycode.toUnicode(UrlParser.get(lastPage.url).hostname) : site.value.domain;
    }
    return null;
});

function readMessages() {
    history.value?.readMessages();
}

let selectedMessagesDescr = computed(() => {
    let count = selectedMessages.value.length;
    return __(StringHelper.getSclon(
        count,
        __('Выбрано %d сообщение'),
        __('Выбрано %d сообщения'),
        __('Выбрано %d сообщений')
    ), count);
});

function clearSelectedMessages() {
    history.value.clearSelectedMessages();
}

let integrationPlatformsForIcon = computed(() => {
    let result: OperatorApplicationApi.OperatorGetParamsPlatformOpenApiModel[] = [];
    let integration = props.userdata.integration;
    if (integration) {
        let dictionary = OperatorAccountStore.integrationPlatformDictionary.value;
        let platformIds = [integration.aggregationPlatformId, integration.platformId];
        for (let platformId of platformIds) {
            if (platformId) {
                if (dictionary[platformId]) {
                    result.push(dictionary[platformId]);
                }
            }
        }
    }
    return result;
});

async function onExportDialog(payload: OperatorApplicationExportPayloadDialogInterface) {
    let p: OperatorApplicationApi.OperatorExportClientToEmailOpenApiModel = {
        username: props.userdata.username,
        email: payload.email,
        messageIds: selectedMessages.value.map(message => message.id),
        forClient: payload.forClient
    };
    (new OperatorApiRequest({
        url: "/message/exportToEmail",
        p
    })).save();
}

let canExportChat = computed(() => {
    return OperatorAccountStore.checkAccess(OperatorAccountStore.data.value.accessRights.canExportChat, props.userdata.siteId);
});

async function toggleMute() {
    toggleClientMute(props.userdata);
}


function selectedMessagesToText(): string {
    return messagesToText(selectedMessages.value);
}

function messagesToText(messages: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel[]): string {
    if (messages.length) {
        return messages.map(message => {
            if (messages.length == 1) {
                return message.text;
            }
            let sender = props.userdata.displayDescr;
            if (!message.isSendByClient) {
                let login = message.operatorLogin;
                let operator = OperatorAccountStore.operatorsDictionary.value[login];
                sender = operator ? operator.fio : login;
            }
            let date = (new DateHelper(message.dateTime)).toLocaleDateTimeString();
            return `${sender}, [${date}]\n${message.text}`;
        }).join("\n\n");
    }
    return null;
}

function getSelectedMessageText(messageId?: number): string | null {
    if (messageId && !selectedMessages.value.find(message => message.id == messageId)) {
        let message = ClientUserdataStore.getMessagesByUsername(props.userdata.username).find(message => message.id == messageId);
        if (message) {
            return messagesToText([message]);
        }
    } else {
        return selectedMessagesToText();
    }
    return null;
}

function copySelectedMessages(messageId?: number) {
    let text = getSelectedMessageText(messageId);
    if (text) {
        navigator.clipboard?.writeText(text).then(() => {
        }, (err) => {
            console.error('Could not copy text: ', err);
        });
    }
}

function setReplyToMessageId(messageId?: number) {
    textarea.value?.setReplyToMessageId(messageId);
}


function replyToSelectedMessage() {
    if (selectedMessages.value.length === 1) {
        setReplyToMessageId(selectedMessages.value[0].id);
    }
}

function quoteSelectedMessages(messageId?: number) {
    if (textarea.value) {
        let text: string = getSelectedMessageText(messageId);

        if (text) {
            text = text.split("\n").map(line => {
                return line.length ? `>> ${line}` : line;
            }).join("\n") + "\n\n";
            let model = textarea.value.model().value;
            if (model.text) {
                model.text += `\n\n${text}`;
            } else {
                model.text = text;
            }
            textarea.value.focusTextarea();
        }
    }
}

function onTextareaKeyUp() {
    history.value.onTextareaKeyUp();
}


function onEditMessage(message: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel) {
    if (textarea) {
        textarea.value.editMessage(message);
    }
}

function onReplyMessage(message: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel) {
    setReplyToMessageId(message.id);
}

async function onRemoveMessage(message: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel) {
    let result = false;
    try {
        await ElConfirm(__("Вы уверены, что хотите удалить это сообщение?"));
        let p: OperatorApplicationApi.OperatorMessageRemoveOpenApiModel = {
            messageId: message.id,
            username: props.userdata.username
        }
        result = !(await (new OperatorApiRequest({
            url: "/message/remove",
            p
        })).send()).showMessageOnError();
    } catch (e) {

    }
    return result;
}


function backToBuddyList() {
    OperatorApplicationDialogsStore.setSelectedUsername({
        buddyListId: props.buddyList.id,
        username: null
    });
}

function moveToMessageById(messageId: number) {
    history.value.scrollToMessageById(messageId);
}


let historyStyle = computed(() => {
    let background = OperatorApplicationConfigInstance.historyBackground;
    if (background && !props.disableBackground) {
        background = StringHelper.addSlashes(background);
        let result: any = {
            backgroundImage: `url("${background}")`
        };
        if (!OperatorApplicationConfigInstance.historyBackgroundRepeat) {
            result.backgroundSize = 'cover';
            result.backgroundPosition = 'center bottom';
        }
        return result;
    }
    return null;
});


function showFreeDialog() {
    OperatorAccountStore.showFreeDialogForSite(props.site.id);
}


let pinnedMessages = computed(() => [...(props.userdata.pinnedMessages ?? [])].sort((a, b) => a.id > b.id ? 1 : -1));
let pinnedMessageIndex = ref(pinnedMessages.value.length - 1);

watch(computed(() => pinnedMessages.value.length), () => pinnedMessageIndex.value = pinnedMessages.value.length - 1, {
    immediate: true
})


let displayedPinnedMessage = computed(() => {
    return pinnedMessages.value[pinnedMessageIndex.value];
});

function changePinnedMessageIndex(delta: number) {
    let newIndex = pinnedMessageIndex.value + delta;
    let count = pinnedMessages.value.length;
    if (newIndex < 0) {
        newIndex = count - 1;
    } else if (newIndex >= count) {
        newIndex = 0;
    }
    pinnedMessageIndex.value = newIndex;
}

let buddyListItemContextMenu = ref<{
    event: MouseEvent,
    visible: boolean
}>();


function openBuddyListItemContextMenu(event: MouseEvent) {
    let selection = window.getSelection();
    if (!selection || selection.isCollapsed) {
        event.preventDefault();
        buddyListItemContextMenu.value = {
            event,
            visible: true
        }
    }
}

let isShowAcceptDialogButton = computed(() => {
    if (!OperatorAccountStore.isCabinetIframe) {
        if (props.userdata.lastDialog) {
            if (!props.userdata.lastDialog.dtClose) {
                if (props.userdata.lastDialog.isLastUnansweredMessageFromClientWasForAllOperators) {
                    if (props.site.isShowButtonWhenLastClientMessageWasForAllOperators) {
                        return true;
                    }
                }
            }
        }
    }
    return false;
});

let isDialogAcceptRunning = ref(false);

async function acceptDialog() {
    if (!isDialogAcceptRunning.value) {
        isDialogAcceptRunning.value = true;
        try {
            let p: OperatorApplicationApi.OperatorAcceptDialogOpenApiModel = {
                username: props.userdata.username,
                dialogId: props.userdata.lastDialog.id
            };
            let result = await (new OperatorApiRequest({
                url: "/message/acceptDialog",
                p,
                silent: true
            })).send();
            result.showMessageOnError();
            if (result.isSuccess) {
                if (props.userdata.lastDialog?.id === p.dialogId) {
                    props.userdata.lastDialog.isLastUnansweredMessageFromClientWasForAllOperators = false;
                }
            }
        } catch (e) {
            console.error(e);
        }
        isDialogAcceptRunning.value = false;
    }
}

let dialogStatus = computed(() => getLastClientDialogStatus(props.userdata));

let dialogStatusChangeAvailable = computed(() => {
    if (!dialogStatus.value?.isClosed) {
        if (!OperatorAccountStore.isCabinetIframe) {
            return true;
        }
    }
    return false;
})

let changeDialogStatusDialogRef = ref<{
    visible: boolean,
    client: OperatorApplicationApi.OperatorApplicationClientOpenApiModel,
    statusId: string
}>();

async function changeDialogStatus(statusId: string) {
    changeDialogStatusDialogRef.value = {
        visible: true,
        client: props.userdata,
        statusId: statusId
    }
}

function openSearchMessage() {
    showMessageSearch.value = true;
    OperatorApplicationEventManager.emit(EVENT_OPEN_MESSAGE_SEARCH_TAB, props.userdata.username);
}

__expose<DialogChatAreaExposeInterface>({
    selectedMessagesToText,
    history: history as any,
    getSelectedMessages: () => selectedMessages.value
});

return (_ctx: any,_cache: any) => {
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _directive_on_native = _resolveDirective("on-native")!
  const _directive_my_tooltip = _resolveDirective("my-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
            'd-flex flex-column-reverse flex-fill history-column',
            _unref(dragStarted) ? 'file-drag-enter' : null,
            __props.cobrowse ? 'cobrowse' : null
        ]),
    style: _normalizeStyle(_unref(historyStyle)),
    onClickPassive: readMessages,
    onKeypressPassive: readMessages
  }, [
    (_unref(OperatorAccountStore).cabinetClientDialog.value && _unref(props).userdata.type.isReal)
      ? (_openBlock(), _createBlock(CabinetClientDialogFooter, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      (!_unref(isUnavailableBecauseOfLicenseLimit))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_unref(OperatorAccountStore).data.value.accessRights.canSendMessages)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (!_unref(isFree))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        (_unref(textarea))
                          ? (_openBlock(), _createBlock(_component_el_upload, {
                              key: 0,
                              drag: "",
                              action: _unref(uploadAction),
                              multiple: "",
                              class: "h-100 d-flex align-items-center",
                              "on-change": onElUploadChange,
                              "show-file-list": false
                            }, {
                              default: _withCtx(() => [
                                _createVNode(FontAwesomeIcon, {
                                  class: "w-100 upload-icon",
                                  icon: "cloud-upload"
                                })
                              ]),
                              _: 1
                            }, 8, ["action"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(isShowAcceptDialogButton))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          class: "d-block w-100",
                          disabled: _unref(isDialogAcceptRunning),
                          onClick: acceptDialog
                        }, {
                          default: _withCtx(() => [
                            (_unref(isDialogAcceptRunning))
                              ? (_openBlock(), _createBlock(MyLoader, {
                                  key: 0,
                                  class: "mr-1",
                                  style: {"color":"inherit !important"}
                                }))
                              : (_openBlock(), _createBlock(FontAwesomeIcon, {
                                  key: 1,
                                  icon: "message-check",
                                  class: "mr-1"
                                })),
                            _cache[20] || (_cache[20] = _createTextVNode(" Принять диалог ", -1))
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]))
                    : (_openBlock(), _createBlock(OperatorApplicationDialogTextarea, {
                        class: "p-2",
                        client: __props.userdata,
                        ref_key: "textarea",
                        ref: textarea,
                        "unpin-all-buttons": __props.cobrowse,
                        key: __props.userdata.username,
                        onSend: _cache[0] || (_cache[0] = ($event: any) => (_unref(history).scrollToBottom())),
                        onToggleMute: toggleMute,
                        onKeyup: onTextareaKeyUp
                      }, null, 8, ["client", "unpin-all-buttons"]))
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(__)("Отправка сообщений запрещена правами доступа")), 1))
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("h3", null, _toDisplayString(_unref(__)('Превышен лимит подключенных операторов на %s', _unref(site) ? _unref(site).title : "")), 1),
            _createTextVNode(" " + _toDisplayString(_unref(__)("Дождитесь, пока кто-то из операторов не выйдет из сети")), 1)
          ]))
    ]),
    (_openBlock(), _createBlock(OperatorApplicationDialogHistory, {
      class: _normalizeClass(`flex-fill`),
      ref_key: "history",
      ref: history,
      key: __props.userdata.username,
      userdata: __props.userdata,
      "short-message-margin": __props.shortMessageMargin,
      "disable-background": __props.disableBackground,
      "selected-messages": _unref(selectedMessages),
      "onUpdate:selectedMessages": _cache[2] || (_cache[2] = ($event: any) => (_isRef(selectedMessages) ? (selectedMessages).value = $event : selectedMessages = $event)),
      onEditMessage: onEditMessage,
      onRemoveMessage: onRemoveMessage,
      onReplyMessage: onReplyMessage,
      onScrollToMessage: moveToMessageById,
      "cobrowse-enabled": __props.cobrowse
    }, {
      "after-messages": _withCtx(() => [
        (_unref(site) && _unref(site).isFree)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(CoreUiChatHistoryNotification, {
                icon: "exclamation-triangle",
                "icon-class": "text-danger",
                class: "with-shadow",
                text: "",
                "rotate-icon": "",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (showFreeDialogForSite()))
              }, {
                default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                  _createElementVNode("span", { innerHTML: `Бесплатная версия. <a tabindex='' class='link-dashed'>Приобрести лицензию</a>` }, null, -1)
                ]))]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["userdata", "short-message-margin", "disable-background", "selected-messages", "cobrowse-enabled"])),
    (__props.userdata)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_unref(displayedPinnedMessage))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(), _createElementBlock("div", {
                  key: _unref(displayedPinnedMessage).id,
                  class: "d-flex align-items-center cursor-pointer",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (moveToMessageById(_unref(displayedPinnedMessage).id)))
                }, [
                  (_unref(pinnedMessages).length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("div", null, [
                          _withDirectives(_createVNode(MyIconButton, {
                            class: "h-auto",
                            icon: "chevron-up",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (changePinnedMessageIndex(-1)))
                          }, null, 512), [
                            [
                              _directive_on_native,
                              void 0,
                              "click",
                              { stop: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _withDirectives(_createVNode(MyIconButton, {
                            class: "h-auto",
                            icon: "chevron-down",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (changePinnedMessageIndex(1)))
                          }, null, 512), [
                            [
                              _directive_on_native,
                              void 0,
                              "click",
                              { stop: true }
                            ]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(__)("Закреплённое сообщение")) + ": ", 1),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(OperatorApplicationHtmlify, {
                        value: _unref(displayedPinnedMessage).text,
                        bbcode: ""
                      }, null, 8, ["value"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createVNode(MyIconButton, {
                      icon: "thumbtack-slash",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(toggleMessagePin)(_unref(props).userdata.username, _unref(displayedPinnedMessage).id, false)))
                    }, null, 512), [
                      [
                        _directive_on_native,
                        void 0,
                        "click",
                        { stop: true }
                      ]
                    ])
                  ])
                ]))
              ]))
            : _createCommentVNode("", true),
          (!__props.hideTopMenu)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "top-menu d-flex align-items-center min-width-0",
                onContextmenu: _cache[19] || (_cache[19] = ($event: any) => (openBuddyListItemContextMenu($event)))
              }, [
                (_unref(buddyListItemContextMenu))
                  ? (_openBlock(), _createBlock(BuddyListItemContextMenu, {
                      key: 0,
                      visible: _unref(buddyListItemContextMenu).visible,
                      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_unref(buddyListItemContextMenu).visible) = $event)),
                      "buddy-list": __props.buddyList,
                      event: _unref(buddyListItemContextMenu).event,
                      username: _unref(props).userdata.username
                    }, null, 8, ["visible", "buddy-list", "event", "username"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_el_button, {
                    link: "",
                    onClick: backToBuddyList
                  }, {
                    default: _withCtx(() => [
                      _createVNode(FontAwesomeIcon, { icon: "arrow-left" })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("h4", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(integrationPlatformsForIcon), (integrationPlatform) => {
                        return (_openBlock(), _createBlock(OperatorApplicationPlatformIcon, {
                          platform: integrationPlatform,
                          class: "mr-2"
                        }, null, 8, ["platform"]))
                      }), 256)),
                      _createVNode(ClientIconsBeforeName, {
                        userdata: __props.userdata,
                        "only-togglers": "",
                        light: ""
                      }, null, 8, ["userdata"]),
                      _createElementVNode("span", null, _toDisplayString(__props.userdata.displayDescr), 1)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_Transition, {
                        name: "zoom",
                        mode: "out-in"
                      }, {
                        default: _withCtx(() => [
                          (_unref(selectedMessages).length)
                            ? (_openBlock(), _createElementBlock("h4", _hoisted_17, [
                                (_unref(canExportChat))
                                  ? _withDirectives((_openBlock(), _createBlock(OperatorApplicationDialogTopMenuButton, {
                                      key: 0,
                                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_isRef(exportDialog) //@ts-ignore
 ? exportDialog.value = true : exportDialog = true)),
                                      icon: "download",
                                      "class-name": "export"
                                    }, null, 512)), [
                                      [_directive_my_tooltip, _unref(__)('Выгрузить чат')]
                                    ])
                                  : _createCommentVNode("", true),
                                _createVNode(OperatorApplicationExportDialog, {
                                  visible: _unref(exportDialog),
                                  "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => (_isRef(exportDialog) ? (exportDialog).value = $event : exportDialog = $event)),
                                  onSend: onExportDialog
                                }, null, 8, ["visible"]),
                                (_unref(selectedMessages).length === 1)
                                  ? _withDirectives((_openBlock(), _createBlock(OperatorApplicationDialogTopMenuButton, {
                                      key: 1,
                                      icon: "reply",
                                      "class-name": "quote",
                                      onClick: replyToSelectedMessage
                                    }, null, 512)), [
                                      [_directive_my_tooltip, _unref(__)('Ответить')]
                                    ])
                                  : _withDirectives((_openBlock(), _createBlock(OperatorApplicationDialogTopMenuButton, {
                                      key: 2,
                                      icon: "quote-left",
                                      "class-name": "quote",
                                      onClick: quoteSelectedMessages
                                    }, null, 512)), [
                                      [_directive_my_tooltip, _unref(__)('Цитировать')]
                                    ]),
                                _withDirectives(_createVNode(OperatorApplicationDialogTopMenuButton, {
                                  icon: "copy",
                                  "class-name": "copy",
                                  onClick: copySelectedMessages
                                }, null, 512), [
                                  [_directive_my_tooltip, _unref(__)('Копировать')]
                                ]),
                                (__props.userdata.ocode)
                                  ? _withDirectives((_openBlock(), _createBlock(OperatorApplicationDialogTopMenuButton, {
                                      key: 3,
                                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_isRef(sendToSupportDialog) //@ts-ignore
 ? sendToSupportDialog.value = true : sendToSupportDialog = true)),
                                      icon: "question-circle",
                                      "class-name": "send-to-support"
                                    }, null, 512)), [
                                      [_directive_my_tooltip, `Отправить в ТП`]
                                    ])
                                  : _createCommentVNode("", true),
                                (_unref(sendToSupportDialog))
                                  ? (_openBlock(), _createBlock(OperatorApplicationSendToSupportDialog, {
                                      visible: _unref(sendToSupportDialog),
                                      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => (_isRef(sendToSupportDialog) ? (sendToSupportDialog).value = $event : sendToSupportDialog = $event)),
                                      key: __props.userdata.username,
                                      userdata: __props.userdata,
                                      "selected-messages": selectedMessagesToText()
                                    }, {
                                      default: _withCtx(() => [
                                        _withDirectives(_createVNode(OperatorApplicationDialogTopMenuButton, {
                                          icon: "question-circle",
                                          "class-name": "send-to-support"
                                        }, null, 512), [
                                          [_directive_my_tooltip, `Отправить в ТП`]
                                        ])
                                      ]),
                                      _: 1
                                    }, 8, ["visible", "userdata", "selected-messages"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("h4", _hoisted_18, [
                                _withDirectives(_createVNode(OperatorApplicationDialogTopMenuButton, {
                                  icon: "search",
                                  "class-name": "",
                                  purple: false,
                                  onClick: _cache[12] || (_cache[12] = ($event: any) => (openSearchMessage()))
                                }, null, 512), [
                                  [_directive_my_tooltip, _unref(__)(`Поиск`)]
                                ]),
                                ((!_unref(props).userdata.type.isCrossOperatorsChat || _unref(isDirectCrossOperatorsChat)) && _unref(OperatorAccountStore).data.value.accessRights.canStartWebRTCCall)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _withDirectives(_createVNode(OperatorApplicationDialogTopMenuButton, {
                                        icon: "video",
                                        "class-name": "",
                                        purple: false,
                                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_unref(startWebRtcCall)(_unref(props).userdata.username, true)))
                                      }, null, 512), [
                                        [_directive_my_tooltip, `Видеозвонок`]
                                      ]),
                                      _withDirectives(_createVNode(OperatorApplicationDialogTopMenuButton, {
                                        icon: "phone",
                                        "class-name": "",
                                        purple: false,
                                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_unref(startWebRtcCall)(_unref(props).userdata.username, false)))
                                      }, null, 512), [
                                        [_directive_my_tooltip, `Аудиозвонок`]
                                      ])
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]))
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      (_unref(site))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createElementVNode("h4", _hoisted_22, [
                              _createVNode(FontAwesomeIcon, {
                                class: "favicon mr-2",
                                icon: {imgIcon: _unref(getFaviconUrl)(_unref(site).domain), fontAwesomeIcon: 'times', color: 'inherit'}
                              }, null, 8, ["icon"])
                            ]),
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(domain)), 1),
                              (__props.userdata.integration)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _cache[22] || (_cache[22] = _createTextVNode(" / ", -1)),
                                    _createElementVNode("a", {
                                      href: __props.userdata.integration.authLink,
                                      onContextmenu: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"])),
                                      target: "_blank",
                                      class: "text-muted"
                                    }, _toDisplayString(__props.userdata.integration.authDescr), 41, _hoisted_25)
                                  ], 64))
                                : (__props.userdata.lastPage && !_unref(isFree))
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _cache[23] || (_cache[23] = _createTextVNode(" / ", -1)),
                                      _createElementVNode("a", {
                                        href: __props.userdata.lastPage.url,
                                        target: "_blank",
                                        class: "text-muted",
                                        title: __props.userdata.lastPage.url,
                                        onContextmenu: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"]))
                                      }, _toDisplayString(__props.userdata.lastPage.title), 41, _hoisted_26)
                                    ], 64))
                                  : _createCommentVNode("", true),
                              (_unref(isFree))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _cache[24] || (_cache[24] = _createTextVNode(" / ", -1)),
                                    _createVNode(_component_el_button, {
                                      onClick: showFreeDialog,
                                      link: "",
                                      class: "p-0"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(__)("Бесплатная версия")), 1)
                                      ]),
                                      _: 1
                                    })
                                  ], 64))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : (__props.userdata.type.isCrossOperatorsChat)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              (_unref(isDirectCrossOperatorsChat))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (_unref(directCrossOperatorsChatOperator))
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode(_toDisplayString(_unref(getOperatorStatusDescr)(_unref(directCrossOperatorsChatOperator))), 1)
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : (_unref(crossOperatorsChatGroup))
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(_toDisplayString(_unref(crossOperatorsChatGroup).operatorLogins.length) + " " + _toDisplayString(_unref(getSclon)(_unref(crossOperatorsChatGroup).operatorLogins.length, _unref(__)('оператор'), _unref(__)('оператора'), _unref(__)('операторов'))), 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                    ]),
                    _createVNode(_Transition, { name: "zoom" }, {
                      default: _withCtx(() => [
                        (_unref(selectedMessages).length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              _createTextVNode(_toDisplayString(_unref(selectedMessagesDescr)) + ". ", 1),
                              _createVNode(_component_el_button, {
                                onClick: clearSelectedMessages,
                                link: "",
                                class: "lh-0 p-0 h-auto",
                                style: {"font-size":"inherit"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(__)("Отмена")), 1)
                                ]),
                                _: 1
                              })
                            ]))
                          : (_unref(dialogStatus))
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                style: _normalizeStyle({
                                    '--status-color': _unref(dialogStatus).color
                                }),
                                class: "ml-3 lh-0 mt-2"
                              }, [
                                _createVNode(_component_el_dropdown, {
                                  trigger: "click",
                                  disabled: !_unref(dialogStatusChangeAvailable),
                                  onCommand: changeDialogStatus
                                }, {
                                  dropdown: _withCtx(() => [
                                    _createVNode(_component_el_dropdown_menu, null, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(site).dialogStatusList, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                            command: item.id,
                                            disabled: item.id == _unref(dialogStatus)?.id
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(FontAwesomeIcon, {
                                                icon: item.icon,
                                                "icon-style": item.iconStyle,
                                                style: _normalizeStyle({
                                                        color: item.color
                                                    }),
                                                class: "mr-3"
                                              }, null, 8, ["icon", "icon-style", "style"]),
                                              _createTextVNode(" " + _toDisplayString(item.descr), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["command", "disabled"]))
                                        }), 256))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_button_group, { class: "d-flex" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_button, {
                                          class: "pr-2 pl-2 status-button",
                                          type: "primary",
                                          size: "small",
                                          disabled: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(FontAwesomeIcon, {
                                              icon: _unref(dialogStatus).icon,
                                              class: "w-auto",
                                              "icon-style": _unref(dialogStatus).iconStyle
                                            }, null, 8, ["icon", "icon-style"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_button, {
                                          class: "pr-2 pl-2 status-button-with-text",
                                          size: "small",
                                          disabled: !_unref(dialogStatusChangeAvailable)
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(dialogStatus).descr) + " ", 1),
                                            (_unref(dialogStatusChangeAvailable))
                                              ? (_openBlock(), _createBlock(FontAwesomeIcon, {
                                                  key: 0,
                                                  icon: "caret-down",
                                                  class: "ml-3 w-auto",
                                                  bold: ""
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        }, 8, ["disabled"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ], 4))
                            : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    (_unref(changeDialogStatusDialogRef)?.visible)
                      ? (_openBlock(), _createBlock(ChangeDialogStatusDialog, {
                          key: 0,
                          userdata: _unref(changeDialogStatusDialogRef).client,
                          "status-id": _unref(changeDialogStatusDialogRef).statusId,
                          visible: _unref(changeDialogStatusDialogRef).visible,
                          "onUpdate:visible": _cache[17] || (_cache[17] = ($event: any) => ((_unref(changeDialogStatusDialogRef).visible) = $event))
                        }, null, 8, ["userdata", "status-id", "visible"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_el_button, {
                    link: "",
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (_isRef(forceShowSideMenu) //@ts-ignore
 ? forceShowSideMenu.value = !_unref(forceShowSideMenu) : forceShowSideMenu = !_unref(forceShowSideMenu)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(FontAwesomeIcon, { icon: "bars" })
                    ]),
                    _: 1
                  })
                ])
              ], 32))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ], 38))
}
}

})